import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { GalleryComponent } from '../../../shared/components/gallery/gallery.component';
import { InformationPreviewComponent } from '../../../shared/components/information-preview/information-preview.component';
import { GalleryBannerComponent } from '../../../shared/components/gallery-banner/gallery-banner.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../../../shared/components/navbar/navbar.component';
import { NewsGAMCComponent } from '../../../shared/components/news-gamc/news-gamc.component';
import { LocalMessageComponent } from '../../../shared/components/local-message/local-message.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [GalleryComponent, NewsGAMCComponent, InformationPreviewComponent, GalleryBannerComponent, FooterComponent, RouterModule, NavbarComponent, LocalMessageComponent],
  templateUrl: './home-page.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePageComponent implements OnInit {

  constructor(private _cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this._cdr.detectChanges();
  }
}
